<template>
    <div class="card shadow-sm">
        <div class="card-body">
            <h5 class="card-title">
                {{ $t('pages.subscription.cancel.successfully_canceled_title') }}
            </h5>

            <p v-html="$t('pages.subscription.cancel.successfully_canceled', {date: $date($route.query.expiryDate).format('DD.MM.YYYY')})"></p>


            <div class="mt-5">
                <button class="btn btn-outline-dark mr-3" @click="$router.push({name: 'resume-subscription'})">
                    {{ $t('pages.subscription.cancel.changed_my_mind') }}
                </button>
                <a class="cursor-pointer text-muted" @click="$router.push({name: 'subscription'})">
                    {{ $t('pages.subscription.cancel.return') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import StaticLoadingIndicatorIcon from "../../../../Includes/StaticLoadingIndicatorIcon";
import PageHeader from "../../../../Includes/PageHeader";
export default {
    name: "SubscriptionCanceled",
    components: {PageHeader, StaticLoadingIndicatorIcon},
}
</script>

<style scoped>

</style>
